import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { OptionsListElement } from '../../../Blocks/components/common/StyledEditables';

const Mail = () =>
<OptionsListElement>
    <Icon name="mail" color="white" size={24} />
  </OptionsListElement>;


export default Mail;